import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import logo from '../assets/hellomoov.png';


function LoginPage() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/.auth/me")
      .then((res) => res.json())
      .then((data) => {
        if (data && data.clientPrincipal) {
          setUser(data.clientPrincipal);
        } else {
          setUser(null);
        }
        setLoading(false);
      })
      .catch(() => {
        setUser(null);
        setLoading(false);
      });
  }, []);

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500 text-lg animate-pulse">Chargement...</p>
      </div>
    );

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="bg-white shadow-md rounded-lg p-8 max-w-sm w-full flex flex-col items-center">
        <img
          src={logo}
          alt="Logo"
          className=" h-24 mb-6"
        />
        <div className="flex flex-col gap-4 w-full">
          <a
            href="/.auth/login/aad"
            className="w-full text-center bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-500 transition"
          >
            Se connecter ( Microsoft )
          </a>
        </div>
      </div>
      <p className="mt-6 text-gray-500 text-sm text-center">
        Vous devez vous connecter.
      </p>
    </div>
  );
}

export default LoginPage;
